/* eslint-disable max-len */
import React from 'react'
import calculatePercentage from '../../../../../../../CommonMethods/percentageCalculator';

const ReportTable = ({ data: { records, reportsTotalCount } }) => {

    return(
        <div class=" w-full px-10 relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class="flex px-[6px] mb-8" id="search-result">
                    <table aria-label="Outside Table" class="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[25%]">
                                    <span >Subject
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Max Marks
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Secured Marks
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Percentage
                                    </span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            {records?.map((report,i) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr>
                                        <td class="text-start" id={'subject'+i}>{report?.subject_name}</td>
                                        <td class="text-end" id={'maxmarks'+i}>{report?.max_marks}</td>
                                        <td class="text-end" id={'securedmarks'+i}>{report?.secured_marks}</td>
                                        <td class="text-end" id={'percentage'+i}>                                                        
                                            {isNaN(calculatePercentage(report?.secured_marks, report?.max_marks)) ||
                                                            !isFinite(calculatePercentage(report?.secured_marks, report?.max_marks))
                                                ? '0%'
                                                : `${calculatePercentage(report?.secured_marks, report?.max_marks)}%`}</td>
                                    </tr>
                                </>))}
                        </tbody>
                        {reportsTotalCount === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                        {'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </div>
    )
}
export default ReportTable;   